import styled from 'styled-components';

const ElementWrapper = styled.span`
  display: inline-block;
  outline: none;
`;

export default ElementWrapper;
